import { Box, Stack } from "@mui/material";
import { SUPPORT_TELEPHONE, SUPPORT_WEBFORM_URL } from "@src/appV2/ContactCBHInfo/constants";

import { Button } from "../../components/Button";
import { Text } from "../../components/Text";
import { applyPlatformAwareInteractionStyles } from "../../utils/applyPlatformAwareInteractionStyles";
import { getMutedText, getStrongText } from "../themeHelpers";

interface HelpCenterSupportFooterProps {
  isMobile: boolean;
}

export function HelpCenterSupportFooter(props: HelpCenterSupportFooterProps) {
  const { isMobile } = props;

  return (
    <Stack
      spacing={2}
      sx={(theme) => ({
        alignItems: "center",
        justifyContent: "center",
        paddingTop: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(5),
        borderRadius: theme.borderRadius?.xLarge,
        backgroundColor: theme.palette.background.warning,
      })}
    >
      <Text
        bold
        variant="body1"
        sx={(theme) => ({
          fontFamily: theme.typography.body1.fontFamily,
          fontSize: "1.5rem",
          lineHeight: 1.2,
          color: getStrongText(theme),
          textAlign: "center",
        })}
      >
        Can&apos;t find what you&apos;re looking for?
      </Text>
      <Text variant="body2" sx={(theme) => ({ color: getMutedText(theme), textAlign: "center" })}>
        Reach support directly and we&apos;ll help you right away.
      </Text>
      <Box
        sx={(theme) => ({
          display: "grid",
          width: "100%",
          maxWidth: "25rem",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: theme.spacing(3),
        })}
      >
        <Button fullWidth href={`tel:${SUPPORT_TELEPHONE}`} size="large" variant="primary">
          Call support
        </Button>
        <Button
          fullWidth
          component="a"
          href={SUPPORT_WEBFORM_URL}
          size="large"
          variant="outlined"
          sx={(theme) => ({
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            ...applyPlatformAwareInteractionStyles({
              hoverStyle: {
                borderColor: theme.palette.primary.dark,
                color: theme.palette.primary.dark,
              },
            }),
          })}
        >
          Submit request
        </Button>
      </Box>
    </Stack>
  );
}
